import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import useClient from '../client/apiClient'
import { useRouter } from 'vue-router'

export default function useCargaManual() {

  const tmovimientos = ref([])
  const movimientos = ref([])
  const chofer = ref([])
  const tipoCamion = ref([])
  const movimiento = ref([])
  const choferes = ref([])
  const tcamiones = ref([])
  const movimientosDelete = ref([])
  const messages = ref([])

  const client = useClient()
  const router = useRouter()

  const proveedores = ref([])
  const clientes = ref([])
  const tipoDocumentos = ref([])
  const destinos = ref([])
  const origenes = ref([])
  const productos = ref([])
  const selectedProductos = ref([])
  const lineas = ref([])
  const first = ref(0)
  const lazyParams = ref({})

  const dt = ref({})
  const loading = ref(false)
  const saving = ref(false)

  const selectedMovimientos = ref()
  const deleteMovimientosDialog = ref(false)
  const deleteMovimientoDialog = ref(false)
  const movimientoDialog = ref(false)
  const submitted = ref(false)

  const filteredProveedores = ref()
  const filteredClientes = ref()
  const filteredChoferes = ref()
  const filteredTCamiones = ref()
  const filteredTMovimientos = ref()
  const filteredTipoDocumentos = ref()
  const filteredDestinos = ref()
  const filteredOrigenes = ref()
  const filteredProductos = ref()

  const storeMovimiento = async (form) => {
    saving.value = false
    let id = form.id
    if (id) {
      //Esta editando el registro
      client.put(`/api/movimientos/${id}`, { 'data': { ...form } })
        .then((response) => {
          cmanual()
          getMovimiento(response.data.data[0].id)
          saving.value = true
        })
    } else {
      //Esta creando el registro
      client.post(`/api/movimientos`, { 'data': { ...form } })
        .then((response) => {
          cmanual()
          getMovimiento(response.data.data[0].id)
          saving.value = true
        })
    }
  }

  const deleteMovimiento = async () => {
    deleteMovimientoDialog.value = false
    saving.value = true
    client.remove(`/api/movimientos/${movimiento.value.id}`)      
      .then(response => {
        if(response.data.success){
          saving.value = false
          movimientos.value = movimientos.value.filter(val => val.id !== movimiento.value.id)
          movimiento.value = {}
          
          setTimeout(() => {
            router.push({ name: 'movimientos.index' })
          }, 1000);          
        }
      })
      .catch(function (error) { 
        loading.value = false
      })
  }

  const deleteSelectedMovimientos = async () => {
    movimientosDelete.value = selectedMovimientos.value.map(({ id }) => id)
    client.remove(`/api/movimientos/destroy/mass`, { data: movimientosDelete.value })
      .then(response => {
        movimientos.value = movimientos.value.filter(
          (val) => !selectedMovimientos.value.includes(val)
        )
        deleteMovimientosDialog.value = false
        selectedMovimientos.value = null
        movimientosDelete.value = null
      })
  }

  const getMovimiento = (id) => {
    client.get(`/api/movimientos/${id}/show`).then(response => {
      movimiento.value = response.data.data.movimiento      
      tmovimientos.value = response.data.data.tmovimientos      
      tcamiones.value = response.data.data.tcamiones
      tipoDocumentos.value = response.data.data.tipoDocumentos
      clientes.value = response.data.data.clientes
      proveedores.value = response.data.data.proveedores
      origenes.value = response.data.data.origenes
      destinos.value = response.data.data.origenes
      choferes.value = response.data.data.choferes
      productos.value = response.data.data.productos

      loading.value = false
    })   
    .catch(function (error) { 
      loading.value = false
    })         
  }

  const cmanual = (event) => {
    client.get(`/api/movimientos/cmanual`).then(response => {
      movimientos.value = response.data.data.movimientos      
      tmovimientos.value = response.data.data.tmovimientos      
      tcamiones.value = response.data.data.tcamiones
      tipoDocumentos.value = response.data.data.tipoDocumentos
      clientes.value = response.data.data.clientes
      proveedores.value = response.data.data.proveedores
      origenes.value = response.data.data.origenes
      destinos.value = response.data.data.origenes
      choferes.value = response.data.data.choferes
      productos.value = response.data.data.productos

      loading.value = false
    })   
    .catch(function (error) { 
      loading.value = false
    })         
  }

  const onPage = (event) => {
    lazyParams.value = event
    cmanual(event)
  }

  const onSort = (event) => {
    lazyParams.value = event
    cmanual(event)
  }

  const onFilter = (event) => {
    lazyParams.value.filters = filters.value 
    cmanual(event)
  }

  const filters = ref({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },

    'id': { value: null, matchMode: FilterMatchMode.EQUALS },
    'tipoCamion': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'tipoDocumento': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'folio': { value: null, matchMode: FilterMatchMode.EQUALS },
    'fecha': { value: null, matchMode: FilterMatchMode.EQUALS },
    'fecha_emision': { value: null, matchMode: FilterMatchMode.EQUALS },    
    'rut_emisor': { value: null, matchMode: FilterMatchMode.EQUALS },    
    'proveedor': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'origen': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'destino': { value: null, matchMode: FilterMatchMode.STARTS_WITH }, 
  })

  const initFilters = () => {
    filters.value = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },

      'id': { value: null, matchMode: FilterMatchMode.EQUALS },
      'tipoCamion': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'tipoDocumento': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'folio': { value: null, matchMode: FilterMatchMode.EQUALS },
      'fecha': { value: null, matchMode: FilterMatchMode.EQUALS },
      'fecha_emision': { value: null, matchMode: FilterMatchMode.EQUALS },    
      'rut_emisor': { value: null, matchMode: FilterMatchMode.EQUALS },    
      'proveedor': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      'origen': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      'destino': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    }
    lazyParams.value.filters = filters.value
    cmanual()
  }

  return {
    tmovimientos,
    chofer,
    tipoCamion,
    movimiento,
    choferes,
    tcamiones,
    proveedores,
    clientes,
    tipoDocumentos,
    destinos,
    origenes,
    dt,
    loading,
    saving,
    filters,
    initFilters,
    selectedMovimientos,
    deleteMovimientosDialog,
    deleteMovimientoDialog,
    movimientoDialog,
    submitted,
    filteredProveedores,
    filteredClientes,
    filteredChoferes,
    filteredTCamiones,
    filteredTMovimientos,
    filteredTipoDocumentos,
    filteredDestinos,
    filteredOrigenes,
    filteredProductos,
    selectedProductos,
    productos,
    lineas,
    messages,
    deleteSelectedMovimientos,
    storeMovimiento,
    deleteMovimiento,
    first,
    lazyParams,
    cmanual,
    onPage,
    onSort,
    onFilter,
    client,
    movimientos,
    router,
    getMovimiento
  }
}